import React, { FC } from 'react'

import { SignInContextNotification } from './SignInContextNotification'

export const FormErrorSection: FC<{
  error?: string | null
  additionalLink?: { url: string; text: string }
}> = ({ error, additionalLink }) =>
  error ? (
    <SignInContextNotification
      type="error"
      text={error}
      additionalLink={additionalLink}
    />
  ) : null
